<template>
  <div class="rolling-text__container" :style="{ 'background-color': bgColor, color: fontColor }">
    <div class="rolling-text__line-container">
      <div
        class="rolling-text__one-line"
        :style="{ 'font-size': `${fontSize}px` }"
        v-for="(item, i) in modifiedItems"
        :key="i"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
const ONE_PER_SECOND = 2;

export default {
  props: {
    items: {
      type: Array,
      default: () => ["EMPTY"],
    },
  },
  data() {
    return {
      modifiedItems: [],
    };
  },
  computed: {
    bgColor() {
      return this.$attrs.bgColor || "transparent";
    },
    fontColor() {
      return this.$attrs.fontColor || "inherit";
    },
    fontSize() {
      return this.$attrs.fontSize || 70;
    },
    height() {
      return this.$attrs.height || 80;
    },
  },
  mounted() {
    // 마지막 아이템을 하나 더 붙임으로써 완성한다.
    this.modifiedItems = (() => {
      if (this.items.length === 0) return [];
      if (this.items.length === 1) return this.items;
      else return [...this.items, this.items[0]];
    })();

    this.$nextTick(() => {
      // rolling-text__line-container first-child
      this.$el.querySelector(".rolling-text__line-container > :first-child").style.animation = `slide-anim ${
        this.modifiedItems.length * ONE_PER_SECOND
      }s forwards infinite`;

      // ADJUST HEIGHT
      this.$el.querySelector(".rolling-text__line-container").style.height = `${this.height}px`;

      const slideAnim = document.createElement("style");
      slideAnim.type = "text/css";
      let bodyHtml = "";
      for (let i = 0; i < this.modifiedItems.length; i++) {
        const percent = (i * 100) / this.modifiedItems.length;
        bodyHtml += `${percent}% { margin-top: -${this.height * i}px; }\n`;
      }

      bodyHtml += `100% { margin-top: -${this.height * (this.modifiedItems.length - 1)}px; }`;

      slideAnim.innerHTML = `
			@keyframes slide-anim {
				${bodyHtml}
			}
		`;
      this.$el.appendChild(slideAnim);
    });
  },
};
</script>

<style scoped>
.rolling-text__container {
  width: 100%;
  max-width: 500px;
}

.rolling-text__line-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.rolling-text__one-line {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  text-align: center;
}

/* .rolling-text__one-line:first-child {
  animation: slide-anim 10s forwards infinite;
} */

/* @keyframes slide-anim {
  0% {
    margin-top: 0px;
  }
  20% {
    margin-top: -50px;
  }
  40% {
    margin-top: -100px;
  }
  60% {
    margin-top: -150px;
  }
  80% {
    margin-top: -200px;
  }

  100% {
    margin-top: -200px;
  }
} */
</style>
